<template>
	<div class="about-body">
		<div class="about-top"></div>
		<!-- <img class="about-top" src="../assets/about/top.png" alt=""> -->
		<div class='about_text'>
			<h1>关于全国大赛</h1>
			<div class="text">
				{{form.About}}
			</div>
		</div>
		<img class="review" src="../assets/about/review1.png" alt="">
		<div class="list">
			<h1>往期十佳理财师部分名单</h1>
			<div class="personnel">
				<div class="personnel_l">
					<p v-for="item of personnel"><span class="personnel_name">{{item.name}}<i></i></span>{{item.company}}</p>
				</div>
				<div class="personnel_r">
					<p v-for="item of personnel2"><span class="personnel_name">{{item.name}}<i></i></span>{{item.company}}</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
        form:Object,
				current: 1,
				personnel:[{
					name:'刘薇',
					company:'北京东方华尔金融咨询有限责任公司',
				},{
					name:'郑泉',
					company:'农行石家庄石门支行',
				},{
					name:'韩东广',
					company:'信泰人寿保险公司黑龙江分公司',
				},{
					name:'孙鹏',
					company:'中信银行鞍山分行',
				},{
					name:'胡桥',
					company:'国泰君安证券公司',
				},{
					name:'王锐',
					company:'中行河北省衡水分行理财中心',
				},{
					name:'王绍英',
					company:'浦发银行石家庄分行',
				},{
					name:'付上维',
					company:'河南海诺理财职业培训学校',
				},{
					name:'杨立杰',
					company:'齐鲁证券',
				},{
					name:'池敏',
					company:'建行石家庄市裕华西路支行',
				},{
					name:'韩琳',
					company:'齐鲁证券',
				},{
					name:'李良平',
					company:'中国银行福建省分行',
				},{
					name:'刘珊珊',
					company:'北京明亚保险经纪公司',
				},{
					name:'王凤尾',
					company:'中美大都会',
				},{
					name:'赵旭辉',
					company:'北京大童保险代理有限公司',
				}],
				personnel2:[{
					name:'李海东',
					company:'泰康人寿保险股份有限公司',
				},{
					name:'周文明',
					company:'郑州大学',
				},{
					name:'宋杨',
					company:'交通银行辽宁省分行',
				},{
					name:'李培燕',
					company:'太平洋人寿保险股份有限公司',
				},{
					name:'刘志强',
					company:'交通银行中山分行',
				},{
					name:'任爽',
					company:'中国邮政储蓄银行北京分行',
				},{
					name:'张耀',
					company:'联讯证券惠州下埔路营业部',
				},{
					name:'张倩',
					company:'北京泛华大童投资管理有限公司',
				},{
					name:'王雪飞',
					company:'中国银行',
				},{
					name:'何光军',
					company:'财商人生理财顾问有限公司',
				},{
					name:'王艺潼',
					company:'中航三星人寿保险有限公司',
				},{
					name:'李丽生',
					company:'中国人民银行呼和浩特中心支行',
				},{
					name:'王天舒',
					company:'中航三星人寿保险有限公司',
				},{
					name:'田小花',
					company:'中国人寿保险股份有限公司中山分公司',
				},{
					name:'胡玉宝',
					company:'中国平安人寿天津分公司',
				}]
			};
		},
    created() {
      this.GetSiteSetting()
    },
    methods:{
      GetSiteSetting() {
      	this.axios.get('/api/SiteSetting/GetSiteSetting')
      	.then(response => {
          console.log(response)
          this.form = response.data.data
      	}).catch(error => {
      		console.log(error)
      	})
      },
    }
	}
</script>

<style scoped="scoped" lang="scss">
	.about-body {
		position: relative;background: #ededed;overflow: hidden;
		.about-top{
			background: url("../assets/about/top.png") no-repeat center center;background-size: 100% cover;height: 500px;text-align: center;background-position-y: -120px;
		}
		.about_text{
			width: 900px;margin: 0 auto;color:#333;margin-top: -80px;margin-bottom: 50px;padding: 35px 30px;background: linear-gradient(-135deg,transparent 30px,#fff 0); box-shadow: 0px 0px 10px #666;
			h1{
				text-align: center;font-size: 30px;position: relative;
			}
			h1::after{
				position: absolute;content: '';width: 190px;height: 2px;background: #333;bottom: -3px;left:50%;margin-left: -95px;
			}
			h1::before{
				position: absolute;content: '';width: 10px;height: 10px;background: #333;border-radius: 50%;bottom: -7px;left:50%;margin-left: 95px;
			}
			.text{
				width: 100%;
				margin-top: 30px;
				line-height: 30px;

			}
		}
		.review{
			width: 100%;
			box-shadow: -2px 6px 9px #666;
		}
		.list{
			width: 900px;margin: 0 auto;color: #333;
			padding: 45px 0;
			h1{text-align: center;padding-bottom: 40px;font-size: 28px;font-weight: bold}
			.personnel{
				overflow: hidden;
				width: 100%;
				.personnel_l,.personnel_r{
					width: 50%;
					float: left;
					.personnel_name{
						width: 64px;
						height: 30px;
						display: inline-block;
						text-align:justify;
						overflow:hidden;
						vertical-align:top;
						margin-right: 20px;
						i{display:inline-block;width:100%;height:0;}
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/about.vue